import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { AccommodationVenue, AccommodationRoom } from "@amazing-wedding/shared-types";

export function useVenues(weddingId: string | null): {
  venues: AccommodationVenue[];
  loading: boolean;
} {
  const [venues, setVenues] = useState<AccommodationVenue[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!weddingId) {
      setVenues([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const q = query(
      collection(db, "weddings", weddingId, "accommodationVenues"),
      orderBy("createdAt", "asc"),
    );
    return onSnapshot(q, (snap) => {
      setVenues(
        snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<AccommodationVenue, "id">) })),
      );
      setLoading(false);
    });
  }, [weddingId]);

  return { venues, loading };
}

export function useRooms(weddingId: string | null): {
  rooms: AccommodationRoom[];
  loading: boolean;
} {
  const [rooms, setRooms] = useState<AccommodationRoom[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!weddingId) {
      setRooms([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const q = query(
      collection(db, "weddings", weddingId, "accommodationRooms"),
      orderBy("createdAt", "asc"),
    );
    return onSnapshot(q, (snap) => {
      setRooms(
        snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<AccommodationRoom, "id">) })),
      );
      setLoading(false);
    });
  }, [weddingId]);

  return { rooms, loading };
}
